
import {
  CompleteAssetVerificationResponse,
  CompleteEmploymentVerificationResponse,
  CompleteIncomeVerificationResponse,
  CompleteSecondaryIncomeVerificationResponse,
  CreateDataFirstSessionResponse,
  CreateIncomeEmploymentSessionResponse,
} from '@ld.consumer-portal/models';
import { EndpointScenarioMap } from './mock.types';

export const dataFirstSessionScenarios: EndpointScenarioMap<CreateDataFirstSessionResponse> = {
  default: {
    sessionUrl: 'https://datafirst.loandepot.com/session/abc123',
    sessionId: 'df-session-001',
    token: 'df-token-abc123',
    expiresAt: new Date(Date.now() + 30 * 60 * 1000).toISOString(),
  },
  plaid: {
    sessionUrl: 'https://cdn.plaid.com/link/v2/stable/link.html',
    sessionId: 'df-session-002',
    token: 'plaid-link-token-xyz789',
    expiresAt: new Date(Date.now() + 30 * 60 * 1000).toISOString(),
  },
  expired: {
    sessionUrl: '',
    sessionId: 'df-session-003',
    expiresAt: new Date(Date.now() - 60 * 1000).toISOString(),
  },
};

export const assetVerificationScenarios: EndpointScenarioMap<CompleteAssetVerificationResponse> = {
  default: {
    success: true,
    message: 'Asset verification completed successfully',
    verifiedAt: new Date().toISOString(),
  },
  success: {
    success: true,
    message: 'All bank accounts have been verified',
    verifiedAt: new Date().toISOString(),
  },
  failed: {
    success: false,
    message: 'Unable to verify assets. Please try again or upload documents manually.',
  },
  'partial-success': {
    success: true,
    message: 'Some accounts were verified. Additional documentation may be required.',
    verifiedAt: new Date().toISOString(),
  },
};

export const incomeEmploymentSessionScenarios: EndpointScenarioMap<CreateIncomeEmploymentSessionResponse> = {
  default: {
    sessionUrl: 'https://income.loandepot.com/session/def456',
    sessionId: 'ie-session-001',
    token: 'ie-token-def456',
    expiresAt: new Date(Date.now() + 30 * 60 * 1000).toISOString(),
  },
  argyle: {
    sessionUrl: 'https://argyle.com/link/session',
    sessionId: 'ie-session-002',
    token: 'argyle-link-token-uvw123',
    expiresAt: new Date(Date.now() + 30 * 60 * 1000).toISOString(),
  },
  expired: {
    sessionUrl: '',
    sessionId: 'ie-session-003',
    expiresAt: new Date(Date.now() - 60 * 1000).toISOString(),
  },
};

export const incomeVerificationScenarios: EndpointScenarioMap<CompleteIncomeVerificationResponse> = {
  default: {
    success: true,
    message: 'Income verification completed successfully',
    verifiedAt: new Date().toISOString(),
  },
  success: {
    success: true,
    message: 'Income has been verified through your employer',
    verifiedAt: new Date().toISOString(),
  },
  failed: {
    success: false,
    message: 'Unable to verify income. Please upload pay stubs or tax returns.',
  },
  'needs-review': {
    success: true,
    message: 'Income data received. Manual review may be required.',
    verifiedAt: new Date().toISOString(),
  },
};

export const employmentVerificationScenarios: EndpointScenarioMap<CompleteEmploymentVerificationResponse> = {
  default: {
    success: true,
    message: 'Employment verification completed successfully',
    verifiedAt: new Date().toISOString(),
  },
  success: {
    success: true,
    message: 'Employment has been verified with your employer',
    verifiedAt: new Date().toISOString(),
  },
  failed: {
    success: false,
    message: 'Unable to verify employment. Please provide employer contact information.',
  },
  'self-employed': {
    success: true,
    message: 'Self-employment income noted. Additional documentation may be required.',
    verifiedAt: new Date().toISOString(),
  },
};

export const secondaryIncomeVerificationScenarios: EndpointScenarioMap<CompleteSecondaryIncomeVerificationResponse> = {
  default: {
    success: true,
    message: 'Secondary income verification completed',
    verifiedAt: new Date().toISOString(),
  },
  success: {
    success: true,
    message: 'Secondary income sources have been verified',
    verifiedAt: new Date().toISOString(),
  },
  failed: {
    success: false,
    message: 'Unable to verify secondary income. Please provide documentation.',
  },
  'no-secondary': {
    success: true,
    message: 'No secondary income reported',
  },
};
